import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, SectionHead } from "./Reveal";

const FAQS = [
  {
    q: "Che cos'è Human Factor?",
    a: "Human Factor è un'applicazione web dedicata alla gestione della Partita IVA in regime forfettario. Riunisce scadenze, adempimenti, documenti e comunicazione con il professionista in un unico spazio digitale.",
  },
  {
    q: "Human Factor è soltanto un software?",
    a: "No. Human Factor combina uno strumento digitale semplice da utilizzare con il supporto di professionisti interni. Non ti limiti a consultare una piattaforma: hai anche un punto di riferimento a cui chiedere assistenza e consulenza.",
  },
  {
    q: "A chi si rivolge?",
    a: "Il servizio è pensato per freelance, professionisti, lavoratori autonomi, artigiani, commercianti e ditte individuali che operano in regime forfettario.",
  },
  {
    q: "Posso parlare direttamente con un professionista?",
    a: "Sì. Uno degli elementi centrali di Human Factor è proprio il canale di comunicazione diretto con il professionista che segue la tua posizione.",
  },
  {
    q: "I professionisti sono esterni?",
    a: "No. Il servizio è gestito da professionisti che fanno parte della struttura Human Factor. Questo permette di integrare meglio assistenza, consulenza e utilizzo della piattaforma.",
  },
  {
    q: "Che cosa posso gestire attraverso Human Factor?",
    a: "Puoi tenere sotto controllo le principali attività relative alla tua Partita IVA, consultare scadenze e adempimenti, organizzare i documenti e comunicare con il professionista.",
  },
  {
    q: "Ho già una Partita IVA. Posso utilizzare Human Factor?",
    a: "Sì. Possiamo analizzare la tua situazione attuale e indicarti come iniziare a utilizzare il servizio.",
  },
  {
    q: "Sto valutando di aprire una Partita IVA. Posso contattarvi?",
    a: "Certamente. Puoi parlarne con un professionista per comprendere se il regime forfettario e il servizio Human Factor sono adatti alla tua situazione.",
  },
  {
    q: "Come posso iniziare?",
    a: "Compila il modulo di contatto. Ti ricontatteremo per conoscere la tua situazione, rispondere alle tue domande e illustrarti il funzionamento del servizio.",
  },
];

export default function Faq() {
  return (
    <section id="faq" data-testid="section-faq" className="relative py-24 lg:py-32">
      <div className="pointer-events-none absolute right-[10%] top-[20%] h-[360px] w-[360px] rounded-full bg-[#1B6EF3]/10 blur-[120px]" />
      <div className="mx-auto max-w-4xl px-5 sm:px-8">
        <SectionHead
          eyebrow="FAQ"
          align="center"
          title={
            <>
              Domande <span className="text-gradient">frequenti</span>
            </>
          }
          sub="Le risposte che cerchi, in chiaro e senza paroloni."
        />

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-12 flex flex-col gap-3.5" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="glow-card rounded-2xl border border-white/10 px-6 py-1"
              >
                <AccordionTrigger className="py-5 text-left font-display text-base font-semibold text-white hover:no-underline sm:text-lg [&[data-state=open]>svg]:text-cyan-300">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-sm leading-relaxed text-slate-400 sm:text-base">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
